import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { EmployeeMessageItem } from "src/app/shared/models/EmployeeMessage.item";
import { EmployeeRecord } from "src/app/shared/models/focusDataModels/EmployeeRecord";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-employee-message",
	templateUrl: "./employee-message.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class EmployeeMessageComponent implements OnInit {
	employeeList: EmployeeRecord[];
	employeeMessageList: EmployeeMessageItem[];
	employeeMessageSelected: EmployeeMessageItem;
	employeeRecordSelected: EmployeeRecord;

	moment: any = moment;

	newMessage: boolean = false;

	userList: User[];

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private focusdata: FocusdataService,
		public venueService: OOVenueService,
		public userService: UserService
	) {}

	ngOnInit(): void {
		this.employeeListGet(this.venueService.subscriptionVenue.value.key);
		this.employeeMessageList = [];
	}

	async deleteMessage(pk: string, sk: string) {
		await this.focuslink.employeeMessageDelete(this.venueService.subscriptionVenue.value.key, pk, sk);
		this.employeeMessageList.splice(
			this.employeeMessageList.findIndex((i) => i.sk === sk),
			1
		);
		this.app.msgSvc.add({ severity: "success", summary: "Employee message deleted" });
	}

	async employeeListGet(venueKey: number) {
		const resp = await this.focusdata.employeeList(venueKey, false);
		this.employeeList = resp.map((i) => new EmployeeRecord(i));
	}

	async employeeSelect(employeeRecordId: number) {
		const resp = await this.focuslink.employeeMessageGetByEmployeeId(this.venueService.subscriptionVenue.value.key, employeeRecordId);
		this.employeeMessageList = resp.map((i) => new EmployeeMessageItem(i));
	}

	returnFromNewEmployeeMessage(payload: EmployeeMessageItem[]) {
		const employeeMessage = payload.find((i) => {
			+i.sk.split("_")[0] === +this.employeeRecordSelected.ID;
		});
		if (employeeMessage) {
			if (!this.employeeMessageList) {
				this.employeeMessageList = [];
			}
			this.employeeMessageList.push(employeeMessage);
		}
	}
}
